module.exports = __webpack_public_path__ + "static/media/receipts_active_es.9fe08253.svg";